import { Module } from 'vuex';
import { TutorialsState } from '@/modules/infodayco/tutorials/store/tutorials.state';
import { TutorialsGetters } from '@/modules/infodayco/tutorials/store/tutorials.getters';
import { TutorialsView } from '@/modules/infodayco/shared/domain/tutorials.view';
import { TutorialsMutations } from '@/modules/infodayco/tutorials/store/tutorials.mutations';
import { TutorialsActions } from '@/modules/infodayco/tutorials/store/tutorials.actions';
import tutorialsRepository from '@/modules/infodayco/shared/repositories/tutorials.repository';
import { Exception } from '@/modules/shared/shared/domain/exceptions/exception';
import { TutorialFile } from '@/modules/infodayco/shared/domain/tutorial-file';
import { VideoTutorial } from '@/modules/infodayco/shared/domain/video-tutorial';
import { fromBuffer } from 'file-type';

const tutorials: Module<TutorialsState, any> = {
    namespaced: true,
    state: {
        view: {
            tutorials: [],
            videos: [],
        },
    },
    getters: {
        [TutorialsGetters.GET_VIEW](state): TutorialsView {
            return state.view;
        },
    },
    mutations: {
        [TutorialsMutations.SET_VIEW](state, view: TutorialsView) {
            state.view = view;
        },
    },
    actions: {
        async [TutorialsActions.FETCH_VIEW]({ commit }) {
            try {
                const view = await tutorialsRepository.getAll();
                commit(TutorialsMutations.SET_VIEW, view);
            } catch (e) {
                return new Exception(e.response);
            }
        },
        async [TutorialsActions.DOWNLOAD_TUTORIAL]({}, tutorial: TutorialFile) {
            try {
                const data = await tutorialsRepository.getTutorial(tutorial);
                const result = await fromBuffer(data.data);
                const file = new Blob([data.data], {
                    type: result ? result.mime : 'application/pdf',
                });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
                return false;
            } catch (e) {
                return new Exception(e.response);
            }
        },
        async [TutorialsActions.DELETE_TUTORIAL]({ dispatch }, tutorial: TutorialFile) {
            try {
                await tutorialsRepository.deleteTutorial(tutorial);
                return await dispatch(TutorialsActions.FETCH_VIEW);
            } catch (e) {
                return new Exception(e.response);
            }
        },
        async [TutorialsActions.DELETE_VIDEO]({ dispatch }, tutorial: VideoTutorial) {
            try {
                await tutorialsRepository.deleteVideoTutorial(tutorial);
                return await dispatch(TutorialsActions.FETCH_VIEW);
            } catch (e) {
                return new Exception(e.response);
            }
        },
    },
};

export default tutorials;
